<template>

	<!-- Projects Table Card -->
	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0, }">
		<template #title>
			<a-row type="flex" align="middle">
				<a-col :span="24" :md="6">
					<h6>订单列表</h6>
					<!-- <p>done this month <span class="text-primary">+40%</span></p>	 -->
				</a-col>
				<a-col :span="24" :lg="12">
					<a-range-picker @change="rangChange" format="YYYY-MM-DD" size="small" v-model="selectDate">
					</a-range-picker>
				</a-col>
				<a-col :span="24" :md="6" style="display: flex; align-items: center; justify-content: flex-end">
					<a-radio-group v-model="projectHeaderBtns" size="small" @change="change">
						<a-radio-button value="ALL">ALL</a-radio-button>
						<a-radio-button value="BUY">BUY</a-radio-button>
						<a-radio-button value="SELL">SELL</a-radio-button>
					</a-radio-group>
				</a-col>
			</a-row>
		</template>
		<a-table :columns="columns" :data-source="data" :pagination="pagination" @change="pageChange">

			<!-- <a-space slot="members" slot-scope="members" :size="-12" class="avatar-chips">
				<template v-for="member in members">
					<a-avatar :key="member" size="small" :src="member" />
				</template>
			</a-space>

			<template slot="company" slot-scope="company">
				<h6 class="m-0">
					<img :src="company.logo" width="25" class="mr-10">
					{{ company.name }}
				</h6>
			</template>

			<template slot="completion" slot-scope="completion">
				<span class="font-bold text-muted text-sm">{{ completion.label ? completion.label : completion }}</span>
				<a-progress :percent="completion.value ? completion.value : completion" :show-info="false" size="small"
					:status="completion.status ? completion.status : 'normal'" />
			</template> -->

		</a-table>

		<!-- <div class="table-upload-btn">
			<a-button type="dashed" block>
				<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 6.70711C5.90237 6.31658 5.90237 5.68342 6.29289 5.29289L9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2C10.2652 2 10.5196 2.10536 10.7071 2.29289L13.7071 5.29289C14.0976 5.68342 14.0976 6.31658 13.7071 6.70711C13.3166 7.09763 12.6834 7.09763 12.2929 6.70711L11 5.41421L11 13C11 13.5523 10.5523 14 10 14C9.44771 14 9 13.5523 9 13L9 5.41421L7.70711 6.70711C7.31658 7.09763 6.68342 7.09763 6.29289 6.70711Z" fill="#111827"/>
				</svg>
				Upload New Project
			</a-button>
		</div> -->
	</a-card>
	<!-- / Projects Table Card -->

</template>

<script>
import moment from 'moment';
export default ({
	props: {
		getData: {
			type: Function,
			default: null
		},
		rawData: {
			type: Object,
			default: () => { },
		},
		columns: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		rawData(newVal, oldVal) {
			// 当message prop变化时，执行一些操作
			this.rawData = newVal;
			this.data = this.rawData.list;
			this.pageInit(this.rawData.currPage, this.rawData.totalCount);
		}
	},
	data() {
		return {
			data: [],
			selectDate: [],
			projectHeaderBtns: 'ALL',
			pagination: {
				current: 1,
				defaultPageSize: 5,
				pageSize: 5,
				total: 0,
				showTotal: () => `共 ${0} 条`
			},
		}
	},
	mounted() {
		this.startTime = moment().startOf('month').format("YYYY-MM-DD") + " 00:00:00";
		this.endTime = moment().endOf('day').format("YYYY-MM-DD") + " 23:59:59";
		this.getList()
	},
	methods: {
		change(e) {
			this.projectHeaderBtns = e.target.value
			this.getList();
		},
		pageInit(page, size) {
			this.pagination.current = page;
			this.pagination.total = size;
			this.pagination.showTotal = () => `共 ${size} 条`
		},
		rangChange() {
			this.startTime = this.selectDate[0].format("YYYY-MM-DD") + " 00:00:00"
			this.endTime = this.selectDate[1].format("YYYY-MM-DD") + " 23:59:59"
			this.getList();
		},
		pageChange(pagination, filters, sorter, { currentDataSource }) {
			this.pagination.current = pagination.current;
			this.pagination.pageSize = pagination.pageSize;
			this.getList();
		},
		getList() {
			let params = {}
			params.startTime = this.startTime;
			params.endTime = this.endTime;
			params.page = this.pagination.current
			params.limit = this.pagination.pageSize
			if (this.projectHeaderBtns != "ALL") {
				params.direction = this.projectHeaderBtns
			}
			this.getData(params)

		}
	},
})

</script>